<script lang="ts" setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <div class="search-bar-banner">
    <div class="search-bar-banner__container text-center">
      <div class="search-bar-banner__text pl-lg-1">
        {{ t("banner.text") }}
      </div>
      <a class="search-bar-banner__link pl-lg-2" href="#">
        <span class="search-bar-banner__read_more search-bar-banner__read_more--underlined"></span>
      </a>
    </div>
  </div>
</template>
